// extracted by mini-css-extract-plugin
module.exports = {"dataContainer":"InstagramCarousel_dataContainer__3Eb6B","rowHeader":"InstagramCarousel_rowHeader__1lZXA","snapper":"InstagramCarousel_snapper__3l2xb"};